import PropTypes from 'prop-types';
import React from 'react';

import {
    Box,
    CircularProgress,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TableRow
} from '@mui/material';

import Paginator from 'pages/Search/components/Paginator';

import useStyles from './styles';

const DataTable = ({
    data,
    page,
    pageSize,
    totalCount,
    onPageChange,
    onPageSizeChange,
    getPaginationHref,
    loading
}) => {
    const { classes } = useStyles();
    const [headers, ...rows] = data;

    return (
        <TableContainer className={classes.container}>
            <Table>
                <TableHead>
                    <TableRow>
                        {headers.map((header, index) => (
                            <TableCell key={index} className={classes.headerCell}>
                                {header}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {loading ? (
                        <TableRow>
                            <TableCell colSpan={1000}>
                                <Box className={classes.spinner}>
                                    <CircularProgress />
                                </Box>
                            </TableCell>
                        </TableRow>
                    ) : (
                        rows.map((cells, index) => (
                            <TableRow key={index} hover>
                                {cells.map((value, index) => (
                                    <TableCell key={index}>{value}</TableCell>
                                ))}
                            </TableRow>
                        ))
                    )}
                </TableBody>
                <TableFooter>
                    <TableRow>
                        <td colSpan={headers.length || 1}>
                            <Paginator
                                page={page}
                                rowsPerPage={pageSize}
                                count={totalCount}
                                onPageChange={onPageChange}
                                onRowsPerPageChange={onPageSizeChange}
                                getPaginationHref={getPaginationHref}
                            />
                        </td>
                    </TableRow>
                </TableFooter>
            </Table>
        </TableContainer>
    );
};

DataTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.node)),
    page: PropTypes.number,
    pageSize: PropTypes.number,
    totalCount: PropTypes.number,
    onPageChange: PropTypes.func,
    onPageSizeChange: PropTypes.func,
    getPaginationHref: PropTypes.func,
    loading: PropTypes.bool
};

DataTable.defaultProps = {
    data: [[]],
    page: 1,
    pageSize: 100,
    totalCount: -1,
    loading: false
};

export default DataTable;
